export default __webpack_public_path__ + "static/aditya-b85e0257c932c5611b60fd950e43f7b6.svg";